import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const propTypes = {
  className: PropTypes.string,
  embedUrl: PropTypes.string,
  title: PropTypes.string,
  margin: PropTypes.string
};

/**
 * A component that renders an embedded video and maintains its aspect ratio
 *
 * @component Video
 * 
 * @param {*} props
 * 
 * @prop {string} className
 * @prop {string} embedUrl - the embed url of the video
 * @prop {string} title - the title of the video
 * @prop {string} margin - custom margin to apply to the video
 * 
 * @return {JSX} returns video
 */
const Video = props => {
  const { className, embedUrl, title, margin } = props;

  const noCookieUrl = embedUrl.includes('www.') ? embedUrl.replace('www.youtube.com', 'www.youtube-nocookie.com') : embedUrl.replace('youtube.com', 'www.youtube-nocookie.com');

  return (
    <IframeWrapper className={className} margin={margin}>
      <iframe title={title} src={noCookieUrl + '?modestbranding=1&rel=0&cc_load_policy=1'} frameBorder="0" allowFullScreen></iframe>
    </IframeWrapper>
  );
};

const IframeWrapper = styled.div`
  margin: ${({ margin }) => (margin ? margin : '80px auto')};
  padding-bottom: 56.25%;
  position: relative;
  width: 100%;

  > iframe {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

Video.propTypes = propTypes;

export default Video;
